 
import chroma from 'chroma-js';
import { getColor } from '@/helpers/utils';

const TimePickerStyles = () => {
  const datePickerPalette = chroma
    .scale([
      chroma(getColor('primary')).brighten(2),
      chroma(getColor('primary')).darken(2)
    ])
    .mode('lab')
    .colors(6);

  return (
    <style>
      {`:root {
--rmdp-primary-custom-calendar: ${getColor('primary')};
--rmdp-secondary-custom-calendar: ${datePickerPalette[4]};
--rmdp-shadow-custom-calendar:${datePickerPalette[3]};
--rmdp-today-custom-calendar: var(--falcon-gray-500);
--rmdp-hover-custom-calendar: var(--falcon-gray-200);
--rmdp-deselect-custom-calendar: ${datePickerPalette[4]};
}

.rmdp-container .bg-custom.ep-arrow[direction="top"], .rmdp-ep-shadow:after {
box-shadow:none !important;
}

.custom-calendar .rmdp-day{
width:40.2px;
height: 29.2px;
font-size: 12.8px;
}
.custom-calendar .rmdp-day-picker{
padding:0;
}
.custom-calendar .rmdp-wrapper {
border: 1px solid var(--rmdp-secondary-custom-calendar);
box-shadow: 0 0 5px var(--rmdp-secondary-custom-calendar);
}
.custom-calendar .rmdp-header{
padding:0;
}

.custom-calendar .rmdp-panel-body li {
background-color: var(--rmdp-primary-custom-calendar);
box-shadow: 0 0 2px var(--rmdp-secondary-custom-calendar);
}

.custom-calendar .rmdp-week-day {
color: var(--falcon-body-color) !important;
font-weight:700 !important;
margin-bottom: 8px;
}

.custom-calendar .rmdp-day.rmdp-deactive {
color: var(--rmdp-secondary-custom-calendar);
}
.custom-calendar .rmdp-day:not(.rmdp-deactive) .highlight-red {
color: ${getColor('danger')};
font-weight:600;
}
.custom-calendar .rmdp-range {
background-color: var(--falcon-gray-600);
padding: 2px;
border-radius: .4rem;  
background-clip: content-box;
box-shadow: none;
}
.custom-calendar .rmdp-range.start:not(.force) , .custom-calendar .rmdp-range.end:not(.force) {
border-radius: .4rem !important;  
background-color: var(--rmdp-primary-custom-calendar);
}


.custom-calendar .rmdp-arrow {
border: solid var(--rmdp-primary-custom-calendar);
border-width: 0 2px 2px 0;
}

.custom-calendar .rmdp-arrow-container:hover {
background-color: var(--rmdp-primary-custom-calendar);
box-shadow: 0 0 3px var(--rmdp-secondary-custom-calendar);
}

.custom-calendar .rmdp-panel-body::-webkit-scrollbar-thumb {
background: var(--rmdp-primary-custom-calendar);
}

.custom-calendar .rmdp-day.rmdp-today span {
background-color: var(--rmdp-today-custom-calendar);
}

.custom-calendar .rmdp-rtl .rmdp-panel {
border-left: unset;
border-right: 1px solid var(--rmdp-secondary-custom-calendar);
}

.custom-calendar .rmdp-day.rmdp-selected span:not(.highlight) {
background-color: var(--rmdp-primary-custom-calendar);
box-shadow: 0 0 3px var(--rmdp-shadow-custom-calendar);
}

.custom-calendar .rmdp-day:not(.rmdp-day-hidden) span:hover {
background-color: var(--rmdp-hover-custom-calendar) !important;
border-radius: .3rem !important;  
}

.custom-calendar .b-deselect {
color: white !important;
background-color: var(--rmdp-deselect-custom-calendar) !important;
}

.custom-calendar .rmdp-action-button {
color: var(--rmdp-primary-custom-calendar);
}

.custom-calendar .rmdp-button:not(.rmdp-action-button) {
background-color: var(--rmdp-primary-custom-calendar);
}

.custom-calendar .rmdp-button:not(.rmdp-action-button):hover {
background-color: var(--rmdp-deselect-custom-calendar);
}
.bg-custom.rmdp-wrapper,
.bg-custom .rmdp-month-picker,
.bg-custom .rmdp-year-picker,
.bg-custom .rmdp-time-picker div input,
.rmdp-container .bg-custom.ep-arrow::after {
background-color: var(--falcon-react-datepicker-bg);
color: var(--falcon-emphasis-bg);
border: 1px solid var(--falcon-gray-300);
opacity: 1;
}

.bg-custom .rmdp-day:not(.rmdp-deactive),
.bg-custom .rmdp-time-picker div .rmdp-am,
.bg-custom .rmdp-header-values,
.bg-custom .rmdp-panel-header {
color: var(--falcon-gray-600);
}

.bg-custom .rmdp-day.rmdp-range {
color: white;
}
.bg-custom {
box-shadow: var(--falcon-box-shadow) !important;
}
.bg-custom rmdp-ep-shadow:after {
box-shadow: var(--falcon-box-shadow) !important;
}
.bg-custom .rmdp-panel-body li {
color: var(--falcon-emphasis-bg);
}

.bg-custom .rmdp-day.rmdp-deactive,
.bg-custom .rmdp-day.rmdp-disabled {
color: var(--falcon-emphasis-bg);
}

.rmdp-container .bg-custom.ep-arrow[direction="top"] {
border-bottom: 1px solid var(--falcon-tertiary-bg-rgb);
}

.rmdp-container .bg-custom.ep-arrow[direction="left"] {
border-right: 1px solid var(--falcon-tertiary-bg-rgb);
}

.rmdp-container .bg-custom.ep-arrow[direction="right"] {
border-left: 1px solid var(--falcon-tertiary-bg-rgb);
}

.rmdp-container .bg-custom.ep-arrow[direction="bottom"] {
border-top: 1px solid var(--falcon-tertiary-bg-rgb);
`}
    </style>
  );
};

export default TimePickerStyles;
